export const API_PREFIX = `${window.location.origin}/api`;
export const API_VERSION = '1.0';

const API_URL = `${API_PREFIX}/v${API_VERSION}`;
const API_URL2 = `${API_PREFIX}/v1.0`;

export const API_ENPOINTS = {
  login: `${API_URL}/account/login`,
  passwordRecovery: `${API_URL}/account/passwordRecovery`,
  confirmPasswordRecovery: `${API_URL}/account/confirmPasswordRecovery`,
  account: `${API_URL}/account`,
  acceptEula: `${API_URL}/account/AcceptEULA`,
  accountStatus: `${API_URL}/account/MyStatus`,
  testerManagement: `${API_URL}/TesterManagement`,
  companyManagement: `${API_URL}/companyManagement`,
  LayoutTemplate: `${API_URL}/LayoutTemplate`,
  DinamicTest: `${API_URL}/DynamicTestDetails`,
  testManagement: `${API_URL}/testDetailsManagement`,
  testManagement2: `${API_URL2}/testDetailsManagement`,
  isn: `${API_URL}/IsnIntegration`,
  validate: `${API_URL}/validate`,
  timeZones: `${API_URL}/TypeValue/TimeZones`,
  deviceTypes: `${API_URL}/TypeValue/DeviceType`,
  qcDeviceTypes: `${API_URL}/TypeValue/QCDeviceType`,
  defaultValues: `${API_URL}/DefaultValue`,
};



// WEBPACK FOOTER //
// src/constants/api.js